import * as React from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { FieldControllerProvider } from './FieldControllerContext';
import { FieldGroup } from './FieldGroup';

export type CheckboxGroupFieldProps = {
    name: string;
    required?: boolean;
    disabled?: boolean;
    className?: string;
    children: React.ReactNode;
};

/**
 * A field for a group of checkboxes.
 */
export const CheckboxGroupField = React.forwardRef(function CheckboxGroupField(
    props: CheckboxGroupFieldProps,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    const { control } = useFormContext();
    const controller = useController({
        control,
        name: props.name,
        rules: { required: props.required ? 'Required' : false },
        disabled: props.disabled,
    });
    return (
        <FieldControllerProvider controller={controller}>
            <FieldGroup className={props.className} ref={ref}>
                {props.children}
            </FieldGroup>
        </FieldControllerProvider>
    );
});
